import { render, staticRenderFns } from "./TermsAndConditionsLearninn.vue?vue&type=template&id=85f503be&"
import script from "./TermsAndConditionsLearninn.vue?vue&type=script&lang=ts&"
export * from "./TermsAndConditionsLearninn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports